// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-3Vp-wlts","foot_link":"foot_link-uhHaXqtL","list":"list-2Cg6speT","link":"link-2dgzgihP","copyright":"copyright-3bQWf_X8"};